/**
 * Admin actions
 */
export const ADMIN_ACTIONS = {
  DASHBOARD_VIEWED: 'dashboard_viewed',
  DASHBOARD_EXIT: 'dashboard_exit',
  TAB_CHANGED: 'tab_changed',
  USER_MANAGED: 'user_managed',
  PROJECT_MANAGED: 'project_managed',
  PROJECT_SELECTED: 'project_selected',
  MESSAGE_SENT: 'message_sent',
} as const;
